<template>
  <div class="login-box">
    <div class="ipt-group" :class="{ error: $v.form.account.$error }">
      <input type="text" v-model.trim="form.account" @change="resetErrorTips" />
      <p class="sub-text" :class="{ 'has-text': form.account }">证件号</p>
      <div class="line" :style="`background: ${theme.themeColor}`"></div>
      <vd-tips path="form.account" class="error-tip" />
    </div>
    <div class="ipt-group mb60" :class="{ error: $v.form.username.$error }">
      <input
        type="text"
        v-model.trim="form.username"
        @change="resetErrorTips"
      />
      <p class="sub-text" :class="{ 'has-text': form.username }">学生姓名</p>
      <div class="line" :style="`background:${theme.themeColor}`"></div>
      <vd-tips path="form.username" class="error-tip" />
    </div>
    <el-button
      class="btn-login"
      :style="`background:${theme.buttonBackground}box-shadow:${theme.buttonShadow}`"
      :loading="loading"
      @click="onCaptcha"
    >{{ loading ? '登录中' : '登录' }}</el-button>
    <div v-if="showErrorTips" class="error-msg">输入信息有误，请核实后重新输入!</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Base64 } from 'js-base64'
import { Button } from 'element-ui'
import { required, validationMixin } from '@/utils/mixin_validate'
import tips from '@/assets/json/errorTips'

/**
 * 证件号+学生姓名登录
 */
export default {
  components: {
    ElButton: Button
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        account: {
          required
        },
        username: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      account: {
        required: `请输入证件号`
      },
      username: {
        required: '请输入学生姓名'
      }
    }
  },
  data() {
    return {
      loading: false,
      showErrorTips: false,
      form: {
        account: '',
        username: ''
      }
    }
  },
  computed: {
    ...mapState(['theme', 'site_msg'])
  },
  methods: {
    async onCaptcha() {
      try {
        await this.validationTouch()
        this.loading = true
        const identity = this.form.account.trim()
        // 弹出图形验证码
        this.$verify({
          identity,
          dom_id: 'countdownBtn',
          success_callback: (ticket) => this.login(ticket),
          fail_callback: () => {
            this.loading = false
          },
          close_callback: () => {
            this.loading = false
          }
        })
      } catch (e) {
        this.form.password = ''
        this.loading = false
      }
    },
    async login(ticket) {
      this.loading = true
      const { account, username } = this.form
      const prefix = this.site_msg.accountPrefix || ''
      const userAccount = `${prefix}${account.trim()}`
      const params = {
        account: userAccount,
        password: Base64.encode(username.trim())
      }
      try {
        const { user_info } = await this.$auth(
          'login_account_ticket',
          ...[params.account, params.password, 'egLIJPgY', ticket]
        )
        localStorage.setItem('currentAccount', params.account)
        await this.$emit('success', user_info)
        this.loading = false
      } catch (e) {
        if (e === 'USER_NOT_EXIST_OR_PWD_WRONG') {
          this.showErrorTips = true
        } else {
          if (tips[e] === 'Network Error') {
            this.$message.error('网络异常')
          } else {
            const tip = tips[e] || e || '未知错误，重新登录或联系管理员'
            this.$message.error(tip)
          }
        }
        this.loading = false
        this.$emit('fail', e)
      }
    },
    // 重置错误
    resetErrorTips() {
      this.showErrorTips = false
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
<style lang="scss" scoped>
.error-msg {
  margin: 10px 0 20px 0;
  font-size: 14px;
  color: #F5222D;
  text-align: center;
  width: 360px;
}
</style>
